import { ContactPointRank, ContactPointType } from '@/components/Timeline/types';
import { CONTACTPOINT_COMMENT_STRUCTURE_DEFINITION_EXTENSION } from '@bariendo/lib/extensions';
import { isEmpty } from '@medplum/core';
import { ContactPoint } from '@medplum/fhirtypes';

export function getPrimaryPhone(contactPoint: ContactPoint[] | undefined): ContactPoint | undefined {
  if (!contactPoint || isEmpty(contactPoint)) return undefined;

  const phoneContacts = contactPoint.filter((cp) => cp.system === ContactPointType.PHONE);

  return phoneContacts.find((cp) => cp.rank === ContactPointRank.PRIMARY) ?? phoneContacts[0];
}

export function getPrimaryEmail(contactPoint: ContactPoint[] | undefined): ContactPoint | undefined {
  if (!contactPoint || isEmpty(contactPoint)) return undefined;

  const emailContacts = contactPoint.filter((cp) => cp.system === ContactPointType.EMAIL);

  return emailContacts.find((cp) => cp.rank === ContactPointRank.PRIMARY) ?? emailContacts[0];
}

export function getContactsSortedByRank(telecom?: ContactPoint[], type?: ContactPointType): ContactPoint[] {
  if (!telecom) return [];

  const contacts = type ? (telecom?.filter((contact) => contact.system === type) as ContactPoint[]) : telecom;

  return contacts.sort((a, b) => {
    const rankA = a.rank ?? Infinity;
    const rankB = b.rank ?? Infinity;
    return rankA - rankB;
  });
}
export function getContactLabel(contact: ContactPoint | undefined): string {
  if (!contact) return '';

  if (contact.use) {
    return contact.use.charAt(0).toUpperCase() + contact.use.slice(1);
  }

  return (
    contact.extension?.find((ext) => ext.url === CONTACTPOINT_COMMENT_STRUCTURE_DEFINITION_EXTENSION)?.valueString ?? ''
  );
}
